import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import { getUserInfoAPI } from '@/api'
import router from '@/router'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 1. 用来存储登录成功之后，得到的 token
    token: '',
    userId: '',
    username: '',
    userInfo: {} // 定义用户信息对象

  },
  
  mutations: {
    // 2. 更新 token 的 mutation 函数
    updateToken (state, payload) {
      state.token = payload.token
      state.userId = payload.userId
      state.username = payload.username
    },

    // 更新用户的信息
    updateUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },

    // 合并式更新局部用户信息（如偏好设置开关），避免整体覆盖导致字段丢失
    updateUserPartial (state, payload) {
      state.userInfo = { ...state.userInfo, ...payload }
    },

    // 更新昵称：同步 userInfo，以及侧边栏"某某某的站村"所用的 username
    updateUsername (state, username) {
      state.username = username
      state.userInfo = { ...state.userInfo, username }
    },

    // 清除用户信息和 token
    clearUser(state) {
      state.token = '';
      state.userId = '';
      state.username = '';
      state.userInfo = {};
    }

  },

  actions: {

    // 定义初始化用户基本信息的 action 函数
    async getUserInfoActions (store) {
      const { data: res } = await getUserInfoAPI()
      if (res.status === 0) {
        store.commit('updateUserInfo', res.data)
      }
    },

    

    // 用户登出
    logout({ commit }) {
      commit('clearUser');
      // 清理持久化登录态：token 从未以 'token' 为 key 存储过，
      // 实际登录态由 vuex-persistedstate 存在 localStorage['vuex'] 下，需一并清理
      localStorage.removeItem('vuex');
      localStorage.removeItem('token');
      router.push('/login'); // 跳转到登录页面
    }

  },

  getters: {
    id: state => state.userInfo.id,

    username: state => state.userInfo.username // 用户名

  },

  modules: {
  },
  // 配置为 vuex 的插件
  plugins: [createPersistedState()]
})

export default store
